<script>
import api from '@/command/api'
import DetailFormGroup from '../../../components/DetailFormGroup'
import { postAction, getAction } from '@/command/netTool'
import moment from 'moment'
import { relateTypeList, goodsTypeList } from '@/utils/textFile'

export default {
  name: 'detailBanner',
  data() {
    return {
      ...api.command.getState(),
      detail: {
        imgUrl1: '',
        bannerType: '0',
        relateName: '',
        adaptiveFlag: '0',
        showSecond: '0',
        goodsType: '',
        linkModule: '',
      },
      selectData: [],
      storeData: [],
      goodsTypeData: [],
      linkAddress: [],
      storeDataActive: [],
      luckyDrawList: [],
      liveList: [],
      projectPageList: [],
      attractionsDataActive: [],
      hotZoneConfigDataActive: [],
    }
  },
  watch: {
    'detail.goodsType'(newData, oldData) {
      if (newData) {
        this.handleGoodsType()
      }
    },
  },
  mounted() {
    const { id } = this.$route.query

    getAction('/api/config/farmKingKongItem/list').then((result) => {
      if (result.code == 200) {
        this.selectData = result.data.map((e) => {
          return {
            ...e,
            value: e.code,
          }
        })
      } else {
        this.$message.error(result.msg)
      }
    })

    if (id) {
      api.command.getDetail
        .call(this, {
          url: `/market/farmBanner/get?id=${id}`,
        })
        .then((result) => {
          if (result.imgUrl) {
            const imgUrlArr = result.imgUrl.split(',')
            this.detail.imgUrl1 = imgUrlArr[0]
            this.detail.showType = result.showType.split(',')
          }
          //   if (result.relateType == '1') {
          //     this.detail.linkUrl = `${result.linkUrl.substring(7, result.linkUrl.length)}`
          //   }

          this.$forceUpdate()
        })
    }

    getAction('/api/config/farmGoodsCategory/list').then((result) => {
      if (result.code == 200) {
        this.linkAddress = result.data.map((e) => {
          return {
            ...e,
            value: e.id,
          }
        })
      } else {
        this.$message.error(result.msg)
      }
    })

    this.storeSearch()
  },
  methods: {
    async handleGoodsType(value = '', index) {
      const goodsType = this.detail.goodsType
      let url
      switch (goodsType) {
        case '0':
          url = '/api/goods/farmAgritainment/list' + `?name=${value}`
          break
        case '1':
          url = '/api/goods/farmRoom/getHotelRoomList' + `?name=${value}`
          break
        case '2':
          url = '/api/goods/farmFarmingExperience/list' + `?name=${value}`
          break
        case '3':
          url = '/api/commodity/farmNativeProduct/list' + `?name=${value}`
          break
        case '4':
          url = '/api/goods/farmTicket/getRelationList' + `?productName=${value}`
          break
        case '5':
          url = '/api/hotelRoom/getRelationList' + `?productName=${value}`
          break
      }

      let searchResult = await api.command.search.call(this, {
        url: url,
      })
      this.goodsTypeData = searchResult.map((el) => {
        return {
          name: (el.name || el.productName) + '    ' + (el.mainBodyName || el.linkShopName || ''),
          value: el.id,
          comboFlag: el.comboFlag,
          productComboId: el.productComboId,
        }
      })
    },
    async handleLuckyDrawSearch(value = '') {
      let searchResult = await api.command.search.call(this, {
        url: `/farmActivityDrawPrize/page?name=${value}`,
        host: '/api',
      })
      this.luckyDrawList = searchResult.records.map((el) => {
        return {
          name: el.name,
          value: el.id,
        }
      })
    },
    async handleProjectPageSearch(value = '') {
      let searchResult = await api.command.search.call(this, {
        url: `/farmShowSpecial/getList?name=${value}`,
        host: '/api',
      })
      this.projectPageList = searchResult.map((el) => {
        return {
          name: el.showName,
          value: el.id,
        }
      })
    },
    async handleLiveList(value = '') {
      let searchResult = await api.command.search.call(this, {
        url: `/market/farmLiveRoom/list?name=${value}`,
        host: '/api',
      })
      this.liveList = searchResult.map((el) => {
        return {
          name: el.name,
          value: el.liveRoomId,
        }
      })
    },
    async storeSearch(value = '') {
      let searchResult = await api.command.search.call(this, {
        url: `/api/commodity/farmMainBody/list?mainBodyName=${value}`,
      })
      this.storeData = searchResult.map((el) => {
        return {
          name: el.mainBodyName,
          value: el.id,
        }
      })
    },
    async storeSearchActive(value = '') {
      let searchResult = await api.command.search.call(this, {
        url: `/api/farmActivity/list?appCode=sznc&name=${value}`,
      })
      this.storeDataActive = searchResult.map((el) => {
        return {
          name: el.name,
          value: el.id,
        }
      })
    },
    async attractionsSearchActive(value = '') {
      let searchResult = await api.command.search.call(this, {
        url: `/api/farmTicketScenic/relationList?appCode=sznc&name=${value}`,
      })
      this.attractionsDataActive = searchResult.records.map((el) => {
        return {
          name: el.name,
          value: el.id,
        }
      })
    },
    async hotZoneConfigActive(value = '') {
      let searchResult = await api.command.search.call(this, {
        url: `/api/farmHotZoneConfig/list?name=${value}`,
      })
      this.hotZoneConfigDataActive = searchResult.map((el) => {
        return {
          name: el.name,
          value: el.id,
        }
      })
    },
    getForm1() {
      // 获取appCode
      const appCode = localStorage.getItem('appCode')?.toLocaleLowerCase()
      
      // 根据appCode过滤展示区域数据
      let showTypeData = [
        {
          name: '首页',
          value: '1',
        },
        {
          name: '商城',
          value: '2',
        },
        {
          name: '景点门票',
          value: '4',
        },
        {
          name: '领券中心',
          value: '5',
        },
        {
          name: '启动页',
          value: '6',
        },
        {
          name: '金刚区底部',
          value: '7',
        },
        {
          name: '首页底部',
          value: '8',
        },
        {
          name: '自提专区',
          value: '9',
        },
        {
          name: '金刚区顶部位置',
          value: '10',
        },
      ]
      
      if (appCode === 'ctbl') {
        // 只显示特定的展示区域
        showTypeData = [
          {
            name: '首页',
            value: '1',
          },
          {
            name: '金刚区底部',
            value: '7',
          },
          {
            name: '首页底部',
            value: '8',
          },
          {
            name: '金刚区顶部位置',
            value: '10',
          },
        ]
      }
      
      return {
        title: '基本信息',
        type: 'cardForm',
        data: [
          {
            name: '名称(76字符内)',
            type: 'input',
            key: 'name',
            cols: 12,
            props: {
              maxLength: 76,
            },
            rules: [
              {
                required: true,
              },
            ],
          },
          {
            name: 'Banner展示区域',
            type: 'row',
            cols: 12,
            rules: [
              {
                required: true,
              },
            ],
            children: [
              {
                type: 'checkBoxButton',
                key: 'showType',
                cols: 24,
                typeData: showTypeData,
              },
            ],
          },
          {
            name: '排序序号（0-100）',
            type: 'inputNumber',
            key: 'sort',
            cols: 12,
            props: {
              min: 0,
              max: 100,
            },
          },
          {
            name: '轮播停留时间',
            type: 'inputNumber',
            key: 'showSecond',
            cols: 12,
            props: {
              addonAfter: 's',
              min: 0,
              max: 100,
            },
            // rules: [
            //   {
            //     required: true,
            //     type: 'number'
            //   }
            // ]
          },
          {
            name: '上架时间',
            type: 'datePicker',
            key: 'beginTime',
            cols: 12,
            props: {
              showTime: true,
              format: 'YYYY-MM-DD HH:mm',
              valueFormat: 'YYYY-MM-DD HH:mm:ss',
            },
            rules: [
              {
                required: true,
              },
            ],
          },
          {
            name: '下架时间',
            type: 'datePicker',
            key: 'endTime',
            cols: 12,
            props: {
              showTime: true,
              format: 'YYYY-MM-DD HH:mm',
              valueFormat: 'YYYY-MM-DD HH:mm:ss',
            },
            rules: [
              {
                required: true,
              },
            ],
          },
        ],
      }
    },
    getForm3() {
      let that = this
      return {
        type: 'cardForm',
        title: 'Banner',
        data: [
          {
            type: 'switch',
            key: 'adaptiveFlag',
            name: 'banner高度自适应',
            cols: 3,
            reversal: true,
          },
          {
            name: 'banner类型',
            type: 'select',
            cols: 24,
            gutter: 2,
            key: 'bannerType',
            display: true,
            rules: [
              {
                required: true,
                type: 'string',
              },
            ],
            typeData: [
              { name: '图片', value: '0' },
              { name: '视频', value: '1' },
            ],
          },
          {
            type: 'iconUpload',
            key: 'a1',
            display: true,
            typeData: [
              {
                maxLength: 1,
                key: 'imgUrl1',
                // desc: '@2x   xhdpi <br/> 上传尺寸636*344px',
              },
            ],
            rules: [
              {
                // eslint-disable-next-line max-params
                validator(rule, value, callback, source, options) {
                  if (!that.detail.imgUrl1) {
                    return false
                  } else {
                    return true
                  }
                },
                message: this.detail.bannerType == '1' ? '请上传视频封面' : '请选择图片上传',
              },
            ],
          },
          ...this.bannerTypeData(),
        ],
      }
    },
    bannerTypeData() {
      return [
        {
          type: 'iconUploadVideo',
          display: this.detail.bannerType == '1',
          typeData: [
            {
              maxLength: 1,
              key: 'videoUrl',
              desc: '视频上传尺寸<20M <br /> 支持格式.mov/.mp4/.wmv/.avi',
            },
          ],
        },
      ].filter((d) => d.display)
    },

    getForm2() {
      // 获取appCode
      const appCode = localStorage.getItem('appCode')?.toLocaleLowerCase()
      
      // 根据appCode过滤类型数据
      let filteredRelateTypeList = relateTypeList
      if (appCode === 'ctbl') {
        // 只显示外链和内部链接
        filteredRelateTypeList = [
          {
            text: '外链',
            name: '外链',
            value: '1',
          },
          {
            text: '内部链接',
            name: '内部链接',
            value: '2',
          },
        ]
      }
      
      return {
        title: 'Banner链接',
        type: 'cardForm',
        data: [
          {
            name: '类型',
            type: 'select',
            cols: 12,
            gutter: 10,
            key: 'relateType',
            onChange: () => {
              this.detail.linkUrl = ''
              this.detail.goodsType = ''
              this.detail.drawPrizeId = ''
              this.detail.relateName = ''
              this.detail.showSpecialId = ''
              this.detail.liveRoomId = ''
              this.detail.goodsId = ''
              this.detail.shopId = ''
              this.detail.activityId = ''
              this.detail.linkModule = ''
              this.detail.shopTypeId = ''
              this.detail.hotZoneConfigId = ''
            },
            rules: [
              {
                required: true,
                type: 'string',
              },
            ],
            typeData: filteredRelateTypeList,
          },
          ...this.relateTypeData(),
        ],
      }
    },
    relateTypeData() {
      //   this.detail.linkUrl = null
      return [
        {
          name: '链接地址',
          type: 'input',
          cols: 12,
          gutter: 10,
          key: 'linkUrl',
          maxLength: 100,
          display: this.detail.relateType == '1',
          //   props: {
          //     addonBefore: 'http://'
          //   },
          rules: [
            {
              required: true,
            },
          ],
        },
        {
          name: '商品类型',
          type: 'select',
          cols: 4,
          gutter: 10,
          key: 'goodsType',
          display: this.detail.relateType == '3',
          typeData: goodsTypeList(),
          rules: [
            {
              required: true,
              message: '请选择商品类型',
            },
          ],
        },
        {
          name: '关联抽奖',
          type: 'dropDownInput',
          cols: 12,
          key: 'relateName',
          onInputSearch: this.handleLuckyDrawSearch,
          valueKey: 'drawPrizeId',
          display: this.detail.relateType == '8',
          inputProps: {
            placeholder: '搜索',
            addonBefore: <a-icon type="search" />,
          },
          rules: [
            {
              required: true,
            },
          ],
          typeData: this.luckyDrawList,
        },
        {
          name: '关联专题页',
          type: 'dropDownInput',
          cols: 12,
          key: 'relateName',
          onInputSearch: this.handleProjectPageSearch,
          valueKey: 'showSpecialId',
          display: this.detail.relateType == '7',
          inputProps: {
            placeholder: '搜索',
            addonBefore: <a-icon type="search" />,
          },
          rules: [
            {
              required: true,
            },
          ],
          typeData: this.projectPageList,
        },
        {
          name: '关联直播',
          type: 'dropDownInput',
          cols: 12,
          key: 'relateName',
          onInputSearch: this.handleLiveList,
          valueKey: 'liveRoomId',
          display: this.detail.relateType == '6',
          inputProps: {
            placeholder: '搜索直播',
            addonBefore: <a-icon type="search" />,
          },
          rules: [
            {
              required: true,
            },
          ],
          typeData: this.liveList,
        },
        {
          name: '关联商品',
          type: 'dropDownInput',
          cols: 8,
          key: 'relateName',
          onInputSearch: this.handleGoodsType,
          onMenuClick: (data) => {
            this.detail.comboFlag = data.comboFlag
            this.detail.productComboId = data.productComboId
          },
          valueKey: 'goodsId',
          display: this.detail.relateType == '3',
          inputProps: {
            placeholder: '搜索商品',
            addonBefore: <a-icon type="search" />,
          },
          rules: [
            {
              required: true,
            },
          ],
          typeData: this.goodsTypeData,
        },
        {
          name: '关联店铺',
          type: 'dropDownInput',
          cols: 12,
          key: 'relateName',
          onInputSearch: this.storeSearch,
          valueKey: 'shopId',
          display: this.detail.relateType == '4',
          inputProps: {
            placeholder: '搜索店铺',
            addonBefore: <a-icon type="search" />,
          },
          rules: [
            {
              required: true,
            },
          ],
          typeData: this.storeData,
        },
        {
          name: '关联活动',
          type: 'dropDownInput',
          cols: 12,
          key: 'relateName',
          onInputSearch: this.storeSearchActive,
          valueKey: 'activityId',
          display: this.detail.relateType == '5',
          inputProps: {
            placeholder: '搜索活动',
            addonBefore: <a-icon type="search" />,
          },
          rules: [
            {
              required: true,
            },
          ],
          typeData: this.storeDataActive,
        },
        {
          name: '关联景点',
          type: 'dropDownInput',
          cols: 12,
          key: 'relateName',
          onInputSearch: this.attractionsSearchActive,
          valueKey: 'activityId',
          display: this.detail.relateType == '11',
          inputProps: {
            placeholder: '搜索景点',
            addonBefore: <a-icon type="search" />,
          },
          rules: [
            {
              required: true,
            },
          ],
          typeData: this.attractionsDataActive,
        },
        {
          name: '关联活动页配置',
          type: 'dropDownInput',
          cols: 12,
          key: 'relateName',
          onInputSearch: this.hotZoneConfigActive,
          valueKey: 'hotZoneConfigId',
          display: this.detail.relateType == '12',
          inputProps: {
            placeholder: '搜索关联活动页配置',
            addonBefore: <a-icon type="search" />,
          },
          rules: [
            {
              required: true,
            },
          ],
          typeData: this.hotZoneConfigDataActive,
        },
        {
          name: '链接点',
          type: 'select',
          cols: 12,
          gutter: 10,
          key: 'linkModule',
          display: this.detail.relateType == '2' && this.detail.linkModule != 'product_type',
          typeData: this.selectData,
          rules: [
            {
              required: true,
            },
          ],
        },
        {
          name: '链接点',
          type: 'select',
          cols: 6,
          gutter: 10,
          key: 'linkModule',
          display: this.detail.relateType == '2' && this.detail.linkModule == 'product_type',
          typeData: this.selectData,
          rules: [
            {
              required: true,
            },
          ],
        },
        {
          name: '链接地址',
          type: 'select',
          cols: 6,
          gutter: 10,
          key: 'shopTypeId',
          display: this.detail.relateType == '2' && this.detail.linkModule == 'product_type',
          typeData: this.linkAddress,
          rules: [
            {
              required: true,
            },
          ],
        },
      ].filter((e) => e.display)
    },
    getFoot() {
      const left = [
        {
          name: '提交',
          type: 'primary',
          loading: this.loading,
          sumbit: true,
          onClick: () => {
            if (moment(this.detail.beginTime) > moment(this.detail.endTime)) {
              this.$message.warning('下架时间应在上架时间之后！')
              return
            }

            // if (this.detail.relateType == '1') {
            //   this.detail.linkUrl = `http://${this.detail.linkUrl}`
            // }

            if (this.detail.relateType == '2' && this.detail.linkModule == 'product_type') {
              this.detail.relateName = (
                this.linkAddress.find((e) => e.id == this.detail.shopTypeId) || {
                  name: '',
                }
              ).name
            }

            let obj = {
              ...this.detail,
              imgUrl: [this.detail.imgUrl1].join(','),
              showType: this.detail.showType.join(','),
            }

            api.command[this.detail.id ? 'editPost' : 'create']
              .call(this, {
                url: `/market/farmBanner/${this.detail.id ? 'update' : 'add'}`,
                params: {
                  ...obj,
                  type: '1',
                },
                isPost: false,
              })
              .then(() => {
                this.$router.push('/marketingCenter/bannerActivity')
              })
          },
        },
        {
          name: '取消',
          type: 'default',
          onClick: () => this.$router.push('/marketingCenter/bannerActivity'),
        },
      ]
      const right = [
        {
          name: ` ${this.detail.status == '1' ? '下架' : '上架'} `,
          type: 'default',
          onClick: () => {
            postAction(`/market/farmBanner/${this.detail.status == '1' ? 'down' : 'up'}?id=${this.detail.id}`).then(
              (e) => {
                if (e.code == 200) {
                  this.$message.success(`${this.detail.status == '1' ? '下架成功' : '上架成功'}`)
                  setTimeout(() => {
                    this.$router.push('/marketingCenter/bannerActivity')
                  }, 500)
                } else {
                  this.$message.error(e.msg)
                }
              }
            )
          },
        },
        {
          name: '删除',
          popTitle: '确认删除吗?',
          isPop: true,
          type: 'danger',
          ghost: true,
          onClick: () => {
            api.command.delPost.call(this, {
              url: `/market/farmBanner/delete?id=${this.detail.id}`,
              isPost: false,
            })
            setTimeout(() => {
              this.$router.push('/marketingCenter/bannerActivity')
            }, 500)
          },
        },
      ]
      return {
        left,
        right: this.detail.id && right,
      }
    },
  },
  render() {
    return (
      <DetailFormGroup
        form={this.detail}
        foot={this.getFoot()}
        data={[this.getForm1(), this.getForm2(), this.getForm3()]}
      />
    )
  },
}
</script>
<style lang="less" scoped>
.entityInformation-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
}
</style>
